import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HashtagContextType {
  selectedHashtag: string | null;
  setSelectedHashtag: (hashtag: string | null) => void;
  hashtagRefreshTrigger: number;
  refreshHashtags: () => void;
}

const HashtagContext = createContext<HashtagContextType | undefined>(undefined);

export const useHashtagContext = () => {
  const context = useContext(HashtagContext);
  if (context === undefined) {
    throw new Error('useHashtagContext must be used within a HashtagProvider');
  }
  return context;
};

interface HashtagProviderProps {
  children: ReactNode;
}

export const HashtagProvider: React.FC<HashtagProviderProps> = ({ children }) => {
  const [selectedHashtag, setSelectedHashtag] = useState<string | null>(null);
  const [hashtagRefreshTrigger, setHashtagRefreshTrigger] = useState(0);

  // カスタムのsetSelectedHashtag関数を作成（ログ付き）
  const setSelectedHashtagWithLog = (hashtag: string | null) => {
    setSelectedHashtag(hashtag);
  };

  const refreshHashtags = () => {
    setHashtagRefreshTrigger(prev => prev + 1);
  };

  return (
    <HashtagContext.Provider value={{ 
      selectedHashtag, 
      setSelectedHashtag: setSelectedHashtagWithLog, 
      hashtagRefreshTrigger, 
      refreshHashtags 
    }}>
      {children}
    </HashtagContext.Provider>
  );
}; 